/**
 * Displays a JSON value (an object, an array, ...) as JSON text. Strings are
 * shown as is and a missing value is left blank.
 *
 * Use this instead of React Admin's `TextField` for any field that can hold an
 * object: since 4.16.20 `TextField` renders those as "[object Object]".
 */

import get from "lodash/get";
import { FieldProps, FunctionField, RaRecord } from "react-admin";

interface JsonFieldProps extends FieldProps<RaRecord> {
  // Enforce that source is defined.
  source: string;
}

function formatJson(value: unknown): string | null {
  if (value === null || value === undefined) {
    return null;
  }

  return typeof value === "string" ? value : JSON.stringify(value);
}

function JsonField(props: JsonFieldProps) {
  return (
    <FunctionField
      {...props}
      render={(record: RaRecord) => formatJson(get(record, props.source))}
    />
  );
}

export { formatJson };
export default JsonField;
